
import {
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAIL,
  GET_CLIENT_PROFILE_SUCCESS,
  GET_CLIENT_PROFILE_FAIL,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAIL,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  DELETE_CLIENT,
  ADD_NEW_CLIENT,
  UPDATE_CLIENT,
  ADD_PARTNER_SUCCESS,
  ADD_PARTNER_FAIL,
  ADD_PARTNER
  
} from "./actionTypes";

const INIT_STATE = {
  clients: [],
  clientProfile: {},
  error: {},
  loading:false
};

const clients = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_CLIENT:
        return {
          ...state,
          loading:true
        }
    case ADD_CLIENT_SUCCESS:
      return {
        ...state,
        // clients: [...state.clients, action.payload],
        loading:false
      }

    case ADD_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }

      case ADD_PARTNER:
        return {
          ...state,
          loading:true
        }
    case ADD_PARTNER_SUCCESS:
      return {
        ...state,
        // clients: [...state.clients, action.payload],
        loading:false
      }

    case ADD_PARTNER_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_CLIENT:
        return {
          ...state,
          loading:true
        }
    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client =>
          client.id.toString() === action.payload.id.toString()
            ? { ...client, ...action.payload }
            : client
        ),
        loading:false
      }

    case UPDATE_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_CLIENT:
      return {
        ...state,
        loading:true
      }
    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.filter(
          client => client.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CLIENT_PROFILE_SUCCESS:
      return {
        ...state,
        clientProfile: action.payload,
      }

    case GET_CLIENT_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default clients;
